jQuery(document).ready(function() {
  var target = ".price__current .money";
  // console.log('DivideBuy priceelemtnor target' + target);
  
  // function registerMutationObserver(target, callback, options = { childList: true, subtree: true,characterData: true,attributes: true }) {
  //     const observerTarget = typeof target === 'string' ? document.querySelector(target) : target;
  
  //     if (!observerTarget) {
  //         console.log('MutationObserver target not found:', target);
  //         return;
  //     }
  //     console.info(`MutationObserver is now watching test ${target}`);
  //     const observer = new MutationObserver(callback);
  //     observer.observe(observerTarget, options);
  
  //     return observer;
  // }
  // registerMutationObserver(target, function(mutationsList) {
  //       for (const mutation of mutationsList) {
  //           if (mutation.type === 'childList' || mutation.type === "characterData") {
  //               console.log("target moved");
  //           }
  //       }
  // });
   const observerTarget = typeof target === 'string' ? document.querySelector(target) : target;
    const observer = new MutationObserver(function(mutationsList) {
        for (const mutation of mutationsList) {
            console.log('DOM changed!', mutation);
            // Your custom logic here
        }
    });
    console.log(`observing : ${target}`)
    observer.observe(observerTarget, {
        childList: true,
        subtree: true,
        attributes: true,
        characterData: true,
    });

  jQuery(document).on(target,'DOMSubtreeModified', function () {
    console.log('DOM changed with jquery : ' + target);
});
});